/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateFiscalPrinterLocationDto
 */
export interface CreateUpdateFiscalPrinterLocationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateFiscalPrinterLocationDto
     */
    printerUid: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateFiscalPrinterLocationDto
     */
    healthcareFacilityId?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateFiscalPrinterLocationDto interface.
 */
export function instanceOfCreateUpdateFiscalPrinterLocationDto(value: object): value is CreateUpdateFiscalPrinterLocationDto {
    if (!('printerUid' in value) || value['printerUid'] === undefined) return false;
    return true;
}

export function CreateUpdateFiscalPrinterLocationDtoFromJSON(json: any): CreateUpdateFiscalPrinterLocationDto {
    return CreateUpdateFiscalPrinterLocationDtoFromJSONTyped(json, false);
}

export function CreateUpdateFiscalPrinterLocationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateFiscalPrinterLocationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'printerUid': json['printerUid'],
        'healthcareFacilityId': json['healthcareFacilityId'] == null ? undefined : json['healthcareFacilityId'],
    };
}

export function CreateUpdateFiscalPrinterLocationDtoToJSON(value?: CreateUpdateFiscalPrinterLocationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'printerUid': value['printerUid'],
        'healthcareFacilityId': value['healthcareFacilityId'],
    };
}

